<!-- ══════════════════════════════════════════════════════════ -->
<!-- SHARED CONFIG CONTENT (reusable template)               -->
<!-- ══════════════════════════════════════════════════════════ -->
<ng-template #configContent>
    <app-feed-help [text]="'Widget'" class="" [videoUrl]="'https://youtube.com/video-tutorial'"
        [supportUrl]="'https://meusite.com/suporte'">
    </app-feed-help>
    <div class="card p-1 mb-3">
        <ng-container *ngIf="isWidgetDetailsLoaded; else stepsSkeleton">
            <div class="mb-2 w-full">
                <div class="mt-2 w-full">
                    <p-steps [model]="ctaOptions" [activeIndex]="activeOption ?? 0" [readonly]="false"
                        styleClass="ss-l-widget-steps"></p-steps>
                </div>
            </div>
            <p-panel [toggleable]="true" [toggler]="'header'" [(collapsed)]="stepStatusCollapsed"
                [styleClass]="'ss-l-step-status-card mx-2 mb-2 border-round border-1 ' + (canPublishWidget ? 'border-green-300' : 'surface-border')">
                <ng-template pTemplate="header">
                    <div class="flex align-items-center justify-content-between w-full pr-2">
                        <div class="flex align-items-center gap-2">
                            <i class="pi text-lg"
                                [ngClass]="canPublishWidget ? 'pi-check-circle text-green-500' : 'pi-exclamation-triangle text-yellow-500'"></i>
                            <span class="font-semibold text-sm" [ngClass]="canPublishWidget ? 'text-green-500' : 'text-700'">
                                {{ canPublishWidget ? 'Etapa concluída' : 'Configuração pendente' }}
                            </span>
                        </div>
                        <span class="text-xs text-600">Ver detalhes</span>
                    </div>
                </ng-template>
                <ul class="list-none p-0 m-0 flex flex-column gap-2">
                    <li class="flex align-items-center gap-2">
                        <i class="pi text-lg"
                            [ngClass]="hasWidgetItems ? 'pi-check-circle text-green-500' : 'pi-circle text-400'"></i>
                        <span>Slicks selecionados no widget</span>
                    </li>
                    <li class="flex align-items-center gap-2">
                        <i class="pi text-lg"
                            [ngClass]="hasWidgetItems ? 'pi-check-circle text-green-500' : 'pi-circle text-400'"></i>
                        <span>Aparência personalizada (template)</span>
                    </li>
                    <li class="flex align-items-center gap-2">
                        <i class="pi text-lg"
                            [ngClass]="hasDestinationDefined ? 'pi-check-circle text-green-500' : 'pi-circle text-400'"></i>
                        <span>Destino de exibição definido</span>
                    </li>
                </ul>
            </p-panel>
        </ng-container>
        <ng-template #stepsSkeleton>
            <div class="mt-2 mb-3 w-full flex align-items-center px-2">
                <div class="flex flex-column align-items-center gap-2" style="width: 33%">
                    <p-skeleton shape="circle" size="2rem"></p-skeleton>
                    <p-skeleton width="80px" height="0.75rem"></p-skeleton>
                </div>
                <p-skeleton height="2px" width="100%" styleClass="flex-1 mb-3"></p-skeleton>
                <div class="flex flex-column align-items-center gap-2" style="width: 33%">
                    <p-skeleton shape="circle" size="2rem"></p-skeleton>
                    <p-skeleton width="80px" height="0.75rem"></p-skeleton>
                </div>
                <p-skeleton height="2px" width="100%" styleClass="flex-1 mb-3"></p-skeleton>
                <div class="flex flex-column align-items-center gap-2" style="width: 33%">
                    <p-skeleton shape="circle" size="2rem"></p-skeleton>
                    <p-skeleton width="80px" height="0.75rem"></p-skeleton>
                </div>
            </div>
            <div class="ss-l-step-status-card mx-2 mb-2 border-round border-1 surface-border">
                <div class="flex align-items-center justify-content-between p-3">
                    <div class="flex align-items-center gap-2">
                        <p-skeleton shape="circle" size="1.25rem"></p-skeleton>
                        <p-skeleton width="140px" height="1rem"></p-skeleton>
                    </div>
                    <p-skeleton width="60px" height="0.75rem"></p-skeleton>
                </div>
            </div>
        </ng-template>
    </div>
    <div *ngIf="activeOption === 0">
        <div class="p-0">
            <div class="card shadow-none">
                <div class="flex flex-column mb-4">
                    <label class="w-full ss-g-globalClassLabel">
                        Título
                        <div class="p-inputgroup mt-2">
                            <input type="text" id="title" pInputText class="w-full" (ngModelChange)="onInputChange()"
                                [(ngModel)]="widgetTitle" (input)="checkInputTitle();"
                                [ngClass]="{'ng-invalid': hasErrorTitle, 'ng-dirty': hasErrorTitle}">
                        </div>
                    </label>
                    <div class="flex align-items-center justify-content-between">
                        <small *ngIf="hasErrorTitle" class="p-error">
                            Obrigatório
                        </small>

                    </div>
                </div>
                <div class="flex flex-column mb-4">
                    <label for="typeSelect" class="w-full ss-g-globalClassLabel">
                        Tipo de ingest
                        <p-dropdown [(ngModel)]="selectedWidgetType" id="typeSelect"
                            (ngModelChange)="onFeedTypeChange($event)" [options]="filteredResults" optionLabel="label"
                            optionValue="value" class="w-full mt-2 ss-g-sidebarVendas"
                            placeholder="Selecione o tipo de feed"
                            [ngClass]="{'ng-invalid': hasError1, 'ng-dirty': hasError1}">
                        </p-dropdown>
                    </label>
                    <div class="flex align-items-center justify-content-between">
                        <small *ngIf="hasError1" class="p-error">
                            Obrigatório
                        </small>
                    </div>
                </div>
                <div class="flex flex-column mb-4" *ngIf="selectedWidgetType === 'feeds'">
                    <label for="typeSelect" class="w-full ss-g-globalClassLabel">
                        Selecione Feeds
                        <p-multiSelect [options]="feedsOptions" [(ngModel)]="selectedFeeds" placeholder="Feed"
                            [filter]="false" class="mt-2 ss-g-sidebarVendas  ss-l-multFilter ss-l-multFilter-feed"
                            display="chip" optionLabel="title" optionValue="value" [appendTo]="'body'">
                            <ng-template let-option pTemplate="item">
                                <div class="p-multiselect-item-content chip-wrapper flex align-items-center gap-2">
                                    <i [ngClass]="getSourceIconClass(option.source_id)" class="text-sm text-700"></i>

                                    <span class="text-sm text-900">
                                        {{ option.username || option.title }}
                                    </span>
                                    <div class="chip-wrapper-scroll flex align-items-center gap-2">
                                        <ng-container *ngIf="option.title === 'Uploads'; else defaultChips">
                                            <p-chip class="small-chip p-chip-rounded" label="▯ stories"></p-chip>
                                            <p-chip class="small-chip p-chip-rounded"
                                                label="🗂️ personal_media"></p-chip>
                                            <p-chip class="small-chip p-chip-rounded" label="🏷 tag"></p-chip>
                                            <p-chip class="small-chip p-chip-rounded" label="#hashtag"></p-chip>
                                        </ng-container>

                                        <ng-template #defaultChips>
                                            <p-chip *ngIf="option.feed_type" [label]="
                                            getUnicodeIcon(option.feed_type) +
                                            ' ' +
                                            (option.feed_type === 'hashtag' && option.hashtag_name
                                              ? '#' + option.hashtag_name
                                              : option.feed_type)
                                          " styleClass="small-chip p-chip-rounded p-chip-info">
                                            </p-chip>
                                        </ng-template>


                                        <ng-container *ngFor="let t of getSecondaryTypes(option.type)">
                                            <p-chip [label]="getUnicodeIcon(t) + ' ' + t.toLowerCase()"
                                                [styleClass]="'small-chip p-chip-rounded p-chip-' + getTypeSeverity(t)">
                                            </p-chip>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-template>
                        </p-multiSelect>

                    </label>
                    <div class="flex align-items-center justify-content-between">
                        <small *ngIf="hasErrorFeeds" class="p-error">
                            Obrigatório
                        </small>
                    </div>
                </div>

                <div class="flex flex-column mb-4"
                    *ngIf="(selectedWidgetType === 'manual' || selectedWidgetType === 'tags' || selectedWidgetType === 'feeds' || selectedWidgetType === 'produtos') && !isNewWidget">
                    <label for="typeSelect" class="w-full ss-g-globalClassLabel">
                        Tipo de Slick
                        <p-dropdown [(ngModel)]="selectedSlickType" id="typeSelect" [options]="filteredResultsSlicks"
                            optionLabel="label" optionValue="value" class="w-full mt-2 ss-g-sidebarVendas"
                            (onChange)="onSlickTypeChange($event.value)" appendTo="body"
                            [ngClass]="{'ng-invalid': hasError2, 'ng-dirty': hasError2}">
                        </p-dropdown>
                    </label>
                    <div class="flex align-items-center justify-content-between">
                        <small *ngIf="hasError2" class="p-error">
                            Obrigatório
                        </small>
                    </div>
                </div>

                <div class="flex flex-column mb-4" *ngIf="selectedWidgetType === 'manual' && !isNewWidget">
                    <label for="typeSelect" class="w-full ss-g-globalClassLabel mb-2">Adicione Slicks ao widget</label>
                    <div *ngIf="!isCompactView">
                        <p-pickList #assetsPickList [source]="loading ? skeletonSource : sourceProducts" [target]="targetProducts"
                            (onTargetReorder)="onReorder($event)"
                            targetHeader="Selecionados ({{targetProducts.length}})" [responsive]="true" class="z-2"
                            [dragdrop]="true" sourceFilterPlaceholder="Buscar por nome"
                            targetFilterPlaceholder="Buscar por nome" (onMoveToSource)="onMoveToSource($event)"
                            (onMoveToTarget)="onMoveToTarget($event)">
                            <ng-template pTemplate="sourceHeader">
                                <div>
                                    Disponíveis ({{loading ? 0 : sourceProductsCount}}) <i *ngIf="isDragDrop"
                                        class="pi pi-arrows-alt p-2"></i>
                                </div>
                            </ng-template>
                            <ng-template let-product pTemplate="item">
                                <div *ngIf="loading || product?.__loading; else productContent"
                                    class="flex flex-wrap p-2 align-items-center gap-3">
                                    <p-skeleton width="100px" height="60px" styleClass="mr-2"></p-skeleton>
                                    <div class="flex flex-column ml-3" style="flex: 1;">
                                        <p-skeleton width="150px" height="1.5rem" class="mb-2"></p-skeleton>
                                        <p-skeleton width="100px" height="1.2rem"></p-skeleton>
                                    </div>
                                </div>
                                <ng-template #productContent>
                                    <div class="flex flex-wrap p-2 align-items-center gap-3">
                                        <div class="image-container-9-16">
                                            <img *ngIf="product.thumbnail"
                                                class="image-content shadow-2 flex-shrink-0 border-round"
                                                [src]="product.thumbnail" alt="{{ product.name }}" />
                                        </div>
                                        <div class="flex-1 flex flex-column gap-2">
                                            <span class="font-bold line-clamp-2">{{ getProductDescription(product) }}</span>
                                            <div class="flex align-items-center gap-2">
                                                <i class="pi pi-tag text-sm"></i>
                                                <span>{{ product.type }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-template>
                            <ng-template pTemplate="emptymessagesource">
                                <div class="flex flex-column align-items-center justify-content-center text-center py-4 gap-2">
                                    <i class="pi pi-inbox text-3xl text-400"></i>
                                    <span class="text-sm text-600">Nenhum slick publicado</span>
                                    <a routerLink="/slicks" class="p-button p-button-outlined p-button-sm mt-1" style="text-decoration: none;">
                                        <i class="pi pi-plus mr-2"></i>Publicar Slicks
                                    </a>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="emptymessagetarget">
                                <div class="flex flex-column align-items-center justify-content-center text-center py-4 gap-2">
                                    <i class="pi pi-inbox text-3xl text-400"></i>
                                    <span class="text-sm text-600">Nenhum slick selecionado</span>
                                </div>
                            </ng-template>
                        </p-pickList>
                    </div>
                    <div *ngIf="isCompactView">
                        <p-pickList #assetsPickList [source]="loading ? skeletonSource : sourceProducts" [target]="targetProducts"
                            (onTargetReorder)="onReorder($event)" [dragdrop]="isDragDrop"
                            targetHeader="Selecionados ({{targetProducts.length}})" [responsive]="true" class="z-2"
                            sourceFilterPlaceholder="Buscar por nome" targetFilterPlaceholder="Buscar por nome"
                            (onMoveToSource)="onMoveToSource($event)" (onMoveToTarget)="onMoveToTarget($event)">

                            <ng-template pTemplate="sourceHeader">
                                <div>
                                    Disponíveis ({{loading ? 0 : sourceProductsCount}})
                                    <i *ngIf="isDragDrop" class="pi pi-arrows-alt p-2"></i>
                                </div>
                            </ng-template>

                            <ng-template let-product pTemplate="item">
                                <div *ngIf="loading || product?.__loading; else productContent"
                                    class="flex flex-wrap p-2 align-items-center gap-3">
                                    <p-skeleton width="100px" height="60px" styleClass="mr-2"></p-skeleton>
                                    <div class="flex flex-column ml-3" style="flex: 1;">
                                        <p-skeleton width="150px" height="1.5rem" class="mb-2"></p-skeleton>
                                        <p-skeleton width="100px" height="1.2rem"></p-skeleton>
                                    </div>
                                </div>

                                <ng-template #productContent>
                                    <div class="flex flex-wrap p-2 align-items-center gap-3 product-item">

                                        <!-- Ícone de arraste -->
                                        <div class="drag-handle" (touchstart)="onTouchStart($event)"
                                            (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
                                            <i class="pi pi-arrows-alt p-2"></i>
                                        </div>

                                        <!-- Informações do Produto -->
                                        <div class="image-container-9-16">
                                            <img *ngIf="product.thumbnail"
                                                class="image-content shadow-2 flex-shrink-0 border-round"
                                                [src]="product.thumbnail | sanitizeUrl" alt="{{ product.name }}" />
                                        </div>

                                        <div class="flex-1 flex flex-column gap-2">
                                            <span class="font-bold line-clamp-2">{{ getProductDescription(product) }}</span>
                                            <div class="flex align-items-center gap-2">
                                                <i class="pi pi-tag text-sm"></i>
                                                <span>{{ product.type }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-template>
                            <ng-template pTemplate="emptymessagesource">
                                <div class="flex flex-column align-items-center justify-content-center text-center py-4 gap-2">
                                    <i class="pi pi-inbox text-3xl text-400"></i>
                                    <span class="text-sm text-600">Nenhum slick publicado</span>
                                    <a routerLink="/slicks" class="p-button p-button-outlined p-button-sm mt-1" style="text-decoration: none;">
                                        <i class="pi pi-plus mr-2"></i>Publicar Slicks
                                    </a>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="emptymessagetarget">
                                <div class="flex flex-column align-items-center justify-content-center text-center py-4 gap-2">
                                    <i class="pi pi-inbox text-3xl text-400"></i>
                                    <span class="text-sm text-600">Nenhum slick selecionado</span>
                                </div>
                            </ng-template>
                        </p-pickList>
                    </div>
                </div>
                <div class="flex align-items-center mb-4" *ngIf="canLimitShowItens() && !isNewWidget">
                    <p-inputSwitch [(ngModel)]="limitShowItens" (onChange)="onSwitchChange($event)"
                        class="mr-2"></p-inputSwitch>
                    <label>Limitar quantidade exibida</label>
                </div>
                <div class="flex align-items-center mb-4" *ngIf="limitShowItens && canLimitShowItens()">
                    <div *ngIf="limitShowItens" class="mt-2 w-full">
                        <div class="input-wrapper-vencimento w-full">
                            <p-inputNumber [(ngModel)]="manualValue" class="w-full ss-g-inputM" locale="pt-BR"
                                placeholder="Ex.: 2"></p-inputNumber>
                        </div>
                    </div>
                </div>
                <div class="flex flex-column w-full mt-2" *ngIf="selectedWidgetType === 'tags' && !isNewWidget">
                    <label class="w-full ss-g-globalClassLabel mb-2">Adicione Slicks por tags</label>
                    <div class="p-fluid bg-blue-200 p-2 shadow-none border-black-alpha-30 w-full mb-2">
                        <p-chips [(ngModel)]="valuesSlicksTags" separator=","
                            placeholder="Insira uma tag e aperte ',' ou ⏎"
                            (ngModelChange)="showSlickClearFunction();"></p-chips>
                        <div class="flex-container" *ngIf="showClearSlicksTags">
                            <a class="ss-g-remove-coupon mt-2" (click)="clearSlickMaps()">
                                <i class="pi pi-times"></i> Limpar
                            </a>
                        </div>
                    </div>
                </div>
                <div class="flex flex-column w-full mt-2" *ngIf="selectedWidgetType === 'produtos' && !isNewWidget">
                    <label class="w-full ss-g-globalClassLabel mb-2">Adicione Slicks por produtos</label>
                    <p-multiSelect [options]="produtosIngestOptions" [(ngModel)]="selectedProdutosIngest"
                        placeholder="Selecione produtos" [filter]="true" filterBy="name"
                        class="w-full ss-g-sidebarVendas ss-l-multFilter ss-l-multFilter-feed" display="chip"
                        optionLabel="name" optionValue="value">
                        <ng-template let-option pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <img *ngIf="option.thumbnail" [src]="option.thumbnail" width="28" height="28"
                                    class="border-round" style="object-fit: cover;" />
                                <span class="text-sm text-900">{{ option.name }}</span>
                                <span class="text-sm text-500 ml-auto" *ngIf="option.price">R$ {{ option.price }}</span>
                            </div>
                        </ng-template>
                    </p-multiSelect>
                </div>

            </div>


        </div>
    </div>
    <div *ngIf="activeOption === 1">
        <div class="card shadow-none">
            <div class="flex flex-column mb-4">
                <label class="w-full ss-g-globalClassLabel">Template</label>
                <div *ngFor="let template of filteredTemplates">
                    <div class="field-checkbox surface-border border-1 mb-4 card shadow-none p-0" [ngClass]="{
                            'selected-integration': template.key === selectedTemplate,
                            'disabled-template': isTemplateDisabled(template.key),
                            'cursor-pointer': !isTemplateDisabled(template.key)
                        }" (click)="!isTemplateDisabled(template.key) && onTemplateSelected(template.key)">

                        <p-radioButton [inputId]="template.key" class="ml-2" name="template" [value]="template.key"
                            [(ngModel)]="selectedTemplate" [disabled]="isTemplateDisabled(template.key)">
                        </p-radioButton>

                        <div class="p-col-fixed col-10 flex ss-l-template-opc"
                            style="height: 70.5px; align-items: center;">
                            <i [ngClass]="template.icon" class="mr-2 text-4xl"></i>
                            <div style="display: flex; align-items: center;">
                                <label [for]="template.key" class="ml-2">{{ template.name }}</label>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <!-- DISCOVER options -->
            <!-- DISCOVER options -->
            <div class="flex flex-column" *ngIf="selectedTemplate === 'discover'">

                <!-- Design -->
                <label for="typeSelect" class="w-full ss-g-globalClassLabel">Design</label>
                <div class="mb-2"></div>
                <p-selectButton class="w-full" [options]="discoverLayoutOptions" [(ngModel)]="discoverLayout"
                    optionLabel="label" optionValue="value">
                    <ng-template pTemplate="item" let-opt>
                        <div class="flex align-items-center justify-content-center w-full">
                            <i [ngClass]="opt.icon" style="font-size: 1.1rem;"></i>
                        </div>
                    </ng-template>
                </p-selectButton>

                <div class="border-top-1 surface-border mt-4 mb-4"></div>

                <!-- Badge de Itens do Post -->
                <div class="flex align-items-center justify-content-between mb-2">
                    <label for="typeSelect" class="w-full ss-g-globalClassLabel">Badge de 'Itens do Post'</label>
                    <p-inputSwitch [(ngModel)]="discoverShowPostItemBadge"></p-inputSwitch>
                </div>

                <div class="mt-0">
                    <p-selectButton class="mt-2 w-full" [options]="discoverIconOptions" [(ngModel)]="discoverIcon"
                        optionValue="value">
                        <ng-template pTemplate="item" let-opt>
                            <div class="flex align-items-center justify-content-center w-full">
                                <i [ngClass]="opt.icon"></i>
                            </div>
                        </ng-template>
                    </p-selectButton>
                </div>

                <div class="border-top-1 surface-border mt-4 mb-4"></div>

                <!-- Barra de filtros -->
                <div class="flex align-items-center justify-content-between">
                    <label for="typeSelect" class="w-full ss-g-globalClassLabel">Barra de filtros</label>
                    <p-inputSwitch [(ngModel)]="discoverShowFilterBar"></p-inputSwitch>
                </div>

            </div>

            <div class="flex flex-column mb-4" *ngIf="selectedTemplate === 'popup'  || selectedTemplate === 'carousel'">
                <label for="typeSelect" class="w-full ss-g-globalClassLabel">
                    Posição</label>
                <p-dropdown id="positionSelect" class="mt-2" [options]="popupPositions" appendTo="body"
                    [(ngModel)]="selectedPopupPosition" placeholder="Selecione a posição"></p-dropdown>

            </div>
            <div class="flex flex-column mb-4" *ngIf="selectedTemplate === 'iframe' || selectedTemplate === 'inline'">
                <label for="resolutionSelect" class="w-full ss-g-globalClassLabel">
                    Resolução (pixels)
                </label>
                <p-dropdown [options]="resolutions" class="mt-2" [(ngModel)]="selectedResolution" appendTo="body"
                    placeholder="Selecione uma resolução" (ngModelChange)="onResolutionChange($event)"></p-dropdown>

            </div>
            <div class="flex align-items-center mb-4"
                *ngIf="selectedTemplate === 'inline' || selectedTemplate === 'carousel'">
                <p-inputSwitch [(ngModel)]="showDescription" (onChange)="onSwitchChangeDescription($event)"
                    class="mr-2"></p-inputSwitch>
                <label>Descrição</label>
            </div>

            <div class="flex flex-column mb-4" *ngIf="selectedTemplate === 'popup'">
                <label class="w-full ss-g-globalClassLabel">
                    Highlight</label>
                <div class="p-inputgroup mt-2">
                    <input type="text" id="highlight" pInputText class="w-full" [(ngModel)]="highlight"
                        placeholder="Ex.: Confira aqui!">
                </div>

            </div>
            <div class="flex flex-column mb-4" *ngIf="selectedTemplate === 'popup'">
                <label for="typeSelect" class="w-full ss-g-globalClassLabel">
                    Shape</label>
                <p-dropdown id="shapeSelect" class="mt-2" [options]="shapeOptions" appendTo="body"
                    [(ngModel)]="selectedShape" placeholder="Selecione o shape"></p-dropdown>
            </div>
            <div class="flex align-items-center mb-4"
                *ngIf="selectedTemplate === 'inline'  || selectedTemplate === 'carousel'">
                <p-inputSwitch [(ngModel)]="showProducts" (onChange)="onSwitchChangeProducts($event)"
                    class="mr-2"></p-inputSwitch>
                <label>Exibir Produto</label>
            </div>
            <div class="flex flex-column mb-2"
                *ngIf="(selectedTemplate === 'popup'  || selectedTemplate === 'carousel') && showDescription">
                <label for="bgColor" class="ss-g-globalClassLabel">Cor do fundo</label>
                <div class="mt-2"></div>
                <p-colorPicker class="mt-2 mb-2" id="bgColor" [(ngModel)]="bg_color" format="hex"
                    [style]="{'width':'100%'}"></p-colorPicker>
            </div>
            <div class="flex flex-column mb-2"
                *ngIf="(selectedTemplate === 'popup'  || selectedTemplate === 'carousel') && showDescription">
                <label for="fontColor" class="ss-g-globalClassLabel">Cor da fonte</label>
                <div class="mt-2"></div>
                <p-colorPicker class="mt-2 mb-2" id="fontColor" [(ngModel)]="font_color" format="hex"
                    [style]="{'width':'100%'}"></p-colorPicker>
            </div>

        </div>
    </div>
    <div *ngIf="activeOption === 2">


        <p-tabView class="tabViewEmbbeding" [activeIndex]="activeTabIndex">
            <p-tabPanel *ngIf="hasIntegration">
                <ng-template pTemplate="header">
                    <img [src]="integrationIcon" [alt]="integrationLabel + ' Icon'" class="icon-tab" />
                    <span>{{ integrationLabel }}</span>
                </ng-template>
                <app-edit-widget-store-panel [ctrl]="integrationContext"></app-edit-widget-store-panel>
                <!---->
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <img src="assets/174854.png" alt="HTML Icon" class="icon-tab" />
                    <span>HTML</span>
                </ng-template>
                <!-- Manter em HTML-->
                <div class="mt-4">
                    <p-panel header="Página" [toggleable]="true" [toggler]="'header'" styleClass="mb-3">
                    <div class="flex flex-column mb-4">
                        <label class="w-full ss-g-globalClassLabel">Passo 1 - Adicione o pixel Slicksell ao header de
                            seu
                            site</label>
                        <p>Você só precisa adicionar esse script apenas uma vez ao seu site. Se o script já foi
                            inserido, pule
                            esta etapa.</p>

                        <div class="p-inputgroup ss-g-custom-inputgroup mb-2">
                            <input type="text" pInputText [(ngModel)]="script_share" readonly class="custom-input">
                            <button pButton pRipple type="button" icon="pi pi-copy" (click)="copiarScript()"
                                class="ss-l-custom-button"></button>
                        </div>
                        <p-toast appendTo="body" [baseZIndex]="11020"></p-toast>
                    </div>
                    <div class="flex flex-column mb-4"
                        *ngIf="selectedTemplate === 'carousel' || selectedTemplate === 'grid' || selectedTemplate === 'iframe' || selectedTemplate === 'inline' || selectedTemplate === 'stories'">
                        <p class="mt-4 mb-0"><b>Passo 2 - Adicione o widget às páginas</b></p>
                        <p>Adicione o script abaixo na parte do seu site que gostaria de exibir se widget.</p>

                        <div class="p-inputgroup ss-g-custom-inputgroup">
                            <input type="text" pInputText [(ngModel)]="widget_share" readonly class="custom-input">
                            <button pButton pRipple type="button" icon="pi pi-copy" (click)="copiarWidget()"
                                class="ss-l-custom-button"></button>

                        </div>
                        <div class="mt-2" *ngIf="selectedTemplate === 'iframe'"><b>Obs.:</b> É preciso definir largura e
                            altura
                            para este formato</div>
                    </div>
                    <div class="flex flex-column mb-4" *ngIf="selectedTemplate === 'iframe'">

                        <p>
                            <b>Passo 3 - </b> Para garantir que o iFrame funcione em sua página ou aplicação,
                            certifique-se de que seu domínio já foi incluído em:
                        </p>
                        <p-breadcrumb [model]="breadcrumbItems"></p-breadcrumb>


                    </div>
                    <div class="flex flex-column mb-4" *ngIf="selectedTemplate !== 'iframe'">
                        <p class="mt-4 mb-0"><b>Passo
                                <span
                                    *ngIf="selectedTemplate === 'carousel' || selectedTemplate === 'grid' || selectedTemplate === 'inline' || selectedTemplate === 'stories' || selectedTemplate === 'iframe'; else stepTwo">
                                    3
                                </span>
                                <ng-template #stepTwo>2</ng-template>
                                - Defina em quais páginas exibir o widget</b></p>
                        <p>Defina as URLs ou regras para exibição do widget em suas páginas.</p>



                        <!-- Rule-builder: grupos aninhados com AND/OR, condições Igual/Contém -->
                        <app-rule-group [group]="ruleTree"></app-rule-group>

                    </div>
                    </p-panel>

                    <p-panel header="Devices" [toggleable]="true" [toggler]="'header'" styleClass="mb-3" [collapsed]="true"
                        *ngIf="selectedTemplate !== 'iframe'">
                        <div class="flex align-items-center mb-2">
                            <p-inputSwitch [(ngModel)]="showSmartphones" (onChange)="onSwitchChangeMobile($event)"
                                class="mr-2"></p-inputSwitch>
                            <label>Exibir em <b>Smartphones</b></label>
                        </div>

                        <div class="flex align-items-center">
                            <p-inputSwitch [(ngModel)]="showDesktops" (onChange)="onSwitchChangeDesktop($event)"
                                class="mr-2"></p-inputSwitch>
                            <label>Exibir em <b>Desktops</b></label>
                        </div>
                    </p-panel>

                    <p-panel header="Título" [toggleable]="true" [toggler]="'header'" styleClass="mb-3" [collapsed]="true"
                        *ngIf="selectedTemplate !== 'iframe' && selectedTemplate !== 'popup'">
                        <div class="flex align-items-center" [ngClass]="showWidgetTitle ? 'mb-2' : ''">
                            <p-inputSwitch [(ngModel)]="showWidgetTitle" (onChange)="editWidget(0)" class="mr-2"></p-inputSwitch>
                            <label>Exibir <b>título</b> no widget</label>
                        </div>

                        <ng-container *ngIf="showWidgetTitle">
                            <div class="mb-3">
                                <label class="w-full ss-g-globalClassLabel">Tamanho do título
                                    <div class="mt-2">
                                        <p-dropdown
                                            [options]="titleTagOptions"
                                            [(ngModel)]="widgetTitleTag"
                                            optionLabel="label"
                                            optionValue="value"
                                            appendTo="body"
                                            class="w-full"
                                            (ngModelChange)="editWidget(0)">
                                        </p-dropdown>
                                    </div>
                                </label>
                            </div>

                            <div class="mb-3" *ngIf="nuvemshopStyledTemplates.includes(selectedTemplate)">
                                <label class="w-full ss-g-globalClassLabel">Alinhamento do título
                                    <div class="mt-2">
                                        <p-selectButton
                                            [options]="titleAlignmentOptions"
                                            [(ngModel)]="titleAlignment"
                                            optionLabel="label"
                                            optionValue="value"
                                            class="w-full ss-g-align-select-button"
                                            (onChange)="editWidget(0)">
                                            <ng-template let-item pTemplate="item">
                                                <i [class]="item.icon" [pTooltip]="item.label" tooltipPosition="top"></i>
                                            </ng-template>
                                        </p-selectButton>
                                    </div>
                                </label>
                            </div>

                            <div *ngIf="nuvemshopStyledTemplates.includes(selectedTemplate)">
                                <label class="w-full ss-g-globalClassLabel">Espaço abaixo do título
                                    <div class="mt-2 p-fluid">
                                        <p-inputNumber [(ngModel)]="titleSpacing" suffix=" px" [min]="0" [max]="80" [step]="4"
                                            [showButtons]="true" buttonLayout="horizontal" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                                            class="w-full" (onBlur)="editWidget(0)"></p-inputNumber>
                                    </div>
                                </label>
                            </div>
                        </ng-container>
                    </p-panel>

                    <p-panel [toggleable]="true" [toggler]="'header'" styleClass="mb-3" [collapsed]="true"
                        *ngIf="nuvemshopStyledTemplates.includes(selectedTemplate)">
                        <ng-template pTemplate="header">
                            <div class="flex align-items-center gap-2 w-full">
                                <span class="ss-g-globalClassLabel ss-l-spacing-panel-label text-lg font-semibold">Espaçamento</span>
                                <i class="pi" [ngClass]="isEditingMobileSpacing ? 'pi-mobile' : 'pi-desktop'"
                                    [pTooltip]="isEditingMobileSpacing ? 'Editando: Mobile' : 'Editando: Desktop'" tooltipPosition="top"></i>
                            </div>
                        </ng-template>
                        <div class="pb-3 mb-3 border-bottom-1 surface-border">
                            <div class="flex align-items-center justify-content-between mb-4">
                                <label class="ss-g-globalClassLabel text-lg m-0">Padding horizontal</label>
                                <p-selectButton [options]="spacingUnitOptions" [(ngModel)]="paddingUnit" optionLabel="label"
                                    optionValue="value" (onChange)="scheduleAutoSave()" styleClass="ss-l-unit-selectbutton"></p-selectButton>
                            </div>
                            <div class="flex align-items-end gap-2">
                                <div class="flex-1 p-fluid">
                                    <label class="w-full ss-g-globalClassLabel block mb-2">Esquerda</label>
                                    <p-inputNumber [ngModel]="effectivePaddingLeft" (ngModelChange)="onPaddingChange('X', 'first', $event)"
                                        [suffix]="' ' + paddingUnit" [min]="paddingUnitConfig.min" [max]="paddingUnitConfig.max"
                                        [step]="paddingUnitConfig.step" [maxFractionDigits]="paddingUnitConfig.maxFractionDigits"
                                        [showButtons]="true" buttonLayout="horizontal"
                                        incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
                                </div>
                                <button pButton pRipple type="button" icon="pi pi-link" class="ss-l-anchor-btn p-button-sm p-button-secondary flex-shrink-0"
                                    [ngClass]="!linkPaddingX ? 'p-button-outlined' : ''" (click)="toggleLinkPadding('X')"
                                    [pTooltip]="linkPaddingX ? 'Valores vinculados — clique para tornar independentes' : 'Valores independentes — clique para vincular'"></button>
                                <div class="flex-1 p-fluid">
                                    <label class="w-full ss-g-globalClassLabel block mb-2">Direita</label>
                                    <p-inputNumber [ngModel]="effectivePaddingRight" (ngModelChange)="onPaddingChange('X', 'second', $event)"
                                        [suffix]="' ' + paddingUnit" [min]="paddingUnitConfig.min" [max]="paddingUnitConfig.max"
                                        [step]="paddingUnitConfig.step" [maxFractionDigits]="paddingUnitConfig.maxFractionDigits"
                                        [showButtons]="true" buttonLayout="horizontal"
                                        incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
                                </div>
                            </div>
                        </div>

                        <div class="pb-3 mb-3 border-bottom-1 surface-border">
                            <label class="w-full ss-g-globalClassLabel mb-4 block text-lg">Padding vertical</label>
                            <div class="flex align-items-end gap-2">
                                <div class="flex-1 p-fluid">
                                    <label class="w-full ss-g-globalClassLabel block mb-2">Topo</label>
                                    <p-inputNumber [ngModel]="effectivePaddingTop" (ngModelChange)="onPaddingChange('Y', 'first', $event)"
                                        [suffix]="' ' + paddingUnit" [min]="paddingUnitConfig.min" [max]="paddingUnitConfig.max"
                                        [step]="paddingUnitConfig.step" [maxFractionDigits]="paddingUnitConfig.maxFractionDigits"
                                        [showButtons]="true" buttonLayout="horizontal"
                                        incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
                                </div>
                                <button pButton pRipple type="button" icon="pi pi-link" class="ss-l-anchor-btn p-button-sm p-button-secondary flex-shrink-0"
                                    [ngClass]="!linkPaddingY ? 'p-button-outlined' : ''" (click)="toggleLinkPadding('Y')"
                                    [pTooltip]="linkPaddingY ? 'Valores vinculados — clique para tornar independentes' : 'Valores independentes — clique para vincular'"></button>
                                <div class="flex-1 p-fluid">
                                    <label class="w-full ss-g-globalClassLabel block mb-2">Base</label>
                                    <p-inputNumber [ngModel]="effectivePaddingBottom" (ngModelChange)="onPaddingChange('Y', 'second', $event)"
                                        [suffix]="' ' + paddingUnit" [min]="paddingUnitConfig.min" [max]="paddingUnitConfig.max"
                                        [step]="paddingUnitConfig.step" [maxFractionDigits]="paddingUnitConfig.maxFractionDigits"
                                        [showButtons]="true" buttonLayout="horizontal"
                                        incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
                                </div>
                            </div>
                        </div>

                        <div class="pb-3 mb-3 border-bottom-1 surface-border">
                            <div class="flex align-items-center justify-content-between mb-4">
                                <label class="ss-g-globalClassLabel text-lg m-0">Margin horizontal</label>
                                <p-selectButton [options]="spacingUnitOptions" [(ngModel)]="marginUnit" optionLabel="label"
                                    optionValue="value" (onChange)="scheduleAutoSave()" styleClass="ss-l-unit-selectbutton"></p-selectButton>
                            </div>
                            <div class="flex align-items-end gap-2">
                                <div class="flex-1 p-fluid">
                                    <label class="w-full ss-g-globalClassLabel block mb-2">Esquerda</label>
                                    <p-inputNumber [ngModel]="effectiveMarginLeft" (ngModelChange)="onMarginChange('X', 'first', $event)"
                                        [suffix]="' ' + marginUnit" [min]="marginUnitConfig.min" [max]="marginUnitConfig.max"
                                        [step]="marginUnitConfig.step" [maxFractionDigits]="marginUnitConfig.maxFractionDigits"
                                        [showButtons]="true" buttonLayout="horizontal"
                                        incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
                                </div>
                                <button pButton pRipple type="button" icon="pi pi-link" class="ss-l-anchor-btn p-button-sm p-button-secondary flex-shrink-0"
                                    [ngClass]="!linkMarginX ? 'p-button-outlined' : ''" (click)="toggleLinkMargin('X')"
                                    [pTooltip]="linkMarginX ? 'Valores vinculados — clique para tornar independentes' : 'Valores independentes — clique para vincular'"></button>
                                <div class="flex-1 p-fluid">
                                    <label class="w-full ss-g-globalClassLabel block mb-2">Direita</label>
                                    <p-inputNumber [ngModel]="effectiveMarginRight" (ngModelChange)="onMarginChange('X', 'second', $event)"
                                        [suffix]="' ' + marginUnit" [min]="marginUnitConfig.min" [max]="marginUnitConfig.max"
                                        [step]="marginUnitConfig.step" [maxFractionDigits]="marginUnitConfig.maxFractionDigits"
                                        [showButtons]="true" buttonLayout="horizontal"
                                        incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
                                </div>
                            </div>
                        </div>

                        <div>
                            <label class="w-full ss-g-globalClassLabel mb-4 block text-lg">Margin vertical</label>
                            <div class="flex align-items-end gap-2">
                                <div class="flex-1 p-fluid">
                                    <label class="w-full ss-g-globalClassLabel block mb-2">Topo</label>
                                    <p-inputNumber [ngModel]="effectiveMarginTop" (ngModelChange)="onMarginChange('Y', 'first', $event)"
                                        [suffix]="' ' + marginUnit" [min]="marginUnitConfig.min" [max]="marginUnitConfig.max"
                                        [step]="marginUnitConfig.step" [maxFractionDigits]="marginUnitConfig.maxFractionDigits"
                                        [showButtons]="true" buttonLayout="horizontal"
                                        incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
                                </div>
                                <button pButton pRipple type="button" icon="pi pi-link" class="ss-l-anchor-btn p-button-sm p-button-secondary flex-shrink-0"
                                    [ngClass]="!linkMarginY ? 'p-button-outlined' : ''" (click)="toggleLinkMargin('Y')"
                                    [pTooltip]="linkMarginY ? 'Valores vinculados — clique para tornar independentes' : 'Valores independentes — clique para vincular'"></button>
                                <div class="flex-1 p-fluid">
                                    <label class="w-full ss-g-globalClassLabel block mb-2">Base</label>
                                    <p-inputNumber [ngModel]="effectiveMarginBottom" (ngModelChange)="onMarginChange('Y', 'second', $event)"
                                        [suffix]="' ' + marginUnit" [min]="marginUnitConfig.min" [max]="marginUnitConfig.max"
                                        [step]="marginUnitConfig.step" [maxFractionDigits]="marginUnitConfig.maxFractionDigits"
                                        [showButtons]="true" buttonLayout="horizontal"
                                        incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
                                </div>
                            </div>
                        </div>
                    </p-panel>

                </div>
                <!-- Manter em HTML-->
            </p-tabPanel>
        </p-tabView>




    </div>
</ng-template>

<!-- ══════════════════════════════════════════════════════════ -->
<!-- SHARED FOOTER CONTENT                                     -->
<!-- ══════════════════════════════════════════════════════════ -->
<ng-template #footerContent>
    <div class="flex align-items-center justify-content-end gap-2 flex-wrap">
        <button *ngIf="isCompactView" pButton pRipple label="Fechar" (click)="closeCopyTemplate(0)" class="p-button-outlined"></button>
        <button *ngIf="createWidgetBtn" pButton pRipple label="Criar" [loading]="isLoadingSave"
            (click)="createWidget()"></button>
        <button *ngIf="!createWidgetBtn" pButton pRipple label="Salvar" [loading]="isLoadingSave"
            (click)="editWidget(1)"></button>
        <ng-container *ngIf="!createWidgetBtn">
            <ng-container *ngIf="isWidgetDetailsLoaded; else publishSkeleton">
                <button *ngIf="!widgetPublished" pButton pRipple [icon]="isLoadingSave ? 'pi pi-spin pi-spinner' : 'pi pi-check'" label="Publicar"
                     (click)="widgetPublished = true; editWidget(1)" [disabled]="!canPublishWidget"
                     [pTooltip]="!canPublishWidget ? 'Selecione slicks e defina um destino de exibição para publicar.' : undefined"
                    class="p-button-success" style="width: 143px"></button>
                <button *ngIf="widgetPublished" pButton pRipple [icon]="isLoadingSave ? 'pi pi-spin pi-spinner' : 'pi pi-times'" label="Despublicar"
                 (click)="widgetPublished = false; editWidget(1)"
                    class="p-button-outlined p-button-danger" style="width: 143px"></button>
            </ng-container>
            <ng-template #publishSkeleton>
                <p-skeleton width="143px" height="44px" borderRadius="6px"></p-skeleton>
            </ng-template>
        </ng-container>
    </div>
</ng-template>

<!-- ══════════════════════════════════════════════════════════ -->
<!-- MOBILE: p-sidebar (overlay)                               -->
<!-- ══════════════════════════════════════════════════════════ -->
<p-sidebar *ngIf="isCompactView" [(visible)]="displaySidebar" #sidebar id="ss-l-sideBarBottom"
    class="ss-g-custom-sidebar-width ss-l-sidebar-edit-widget" position="right" [modal]="false">
    <ng-template pTemplate="header">
        <h4 class="mb-0">Configurações</h4>
    </ng-template>
    <ng-container *ngTemplateOutlet="configContent"></ng-container>
    <ng-template pTemplate="footer">
        <ng-container *ngTemplateOutlet="footerContent"></ng-container>
    </ng-template>
</p-sidebar>

<!-- ══════════════════════════════════════════════════════════ -->
<!-- MAIN LAYOUT                                               -->
<!-- ══════════════════════════════════════════════════════════ -->
<div class="flex ss-l-edit-widget-layout">
    <!-- LEFT: Template Preview -->
    <div class="flex-1 ss-l-preview-area" [style.height.px]="!isCompactView ? layoutMaxHeightPx : null">
        <div class="text-center w-full ss-l-preview-container" #containerDiv [ngClass]="{
                'max-w-25rem mx-auto': isCol4
            }" [ngStyle]="selectedTemplate === 'inline' ? { 'min-width': '320px' } : {}">
            <div class="select-button-wrapper mx-auto mb-4">
                <p-selectButton class="mt-5 ss-g-selectButton-50" [options]="landscapeOptions2" *ngIf="!isCompactView"
                    (onChange)="changeLandscape()" [(ngModel)]="valSelect1Video" optionLabel="name">
                    <ng-template let-option pTemplate="item">
                        <div class="flex align-items-center justify-content-center w-full">
                            <i [ngClass]="option.icon" class="mr-2"></i>
                            <span class="font-bold">{{ option.name }}</span>
                        </div>
                    </ng-template>
                </p-selectButton>
            </div>

            <div class="flex align-items-center justify-content-between w-full mb-2">
                <div class="flex align-items-center">
                    <i class="pi pi-eye mr-2 text-xl"></i>
                    <span class="font-bold text-lg">Prévia - {{ capitalizeFirstLetter(selectedTemplate)
                        }}</span>
                </div>
                <div class="button-container" *ngIf="isCompactView">
                    <button pButton pRipple type="button" icon="pi pi-pencil" (click)="onOpenSidebar()"
                        class="border-none button-tag"></button>
                </div>
            </div>
            <div class="w-full p-0 m-0 ss-l-preview-scroll" [ngClass]="{'col-12': selectedTemplate === 'inline' && isCol4, 'col-12 md:col-6 lg:col-4': selectedTemplate === 'inline' && !isCol4}">
                <app-widget-template [templateType]="selectedTemplate" [refreshTrigger]="refreshTrigger"
                    (loadingComplete)="isLoadingSave = false"
                    [popupPosition]="(selectedTemplate === 'popup' || selectedTemplate === 'carousel' || selectedTemplate === 'stories') ? (selectedPopupPosition || 'bottomleft') : 'bottomleft'"
                    [highlight]="(selectedTemplate === 'popup' || selectedTemplate === 'carousel' || selectedTemplate === 'stories') ? highlight : undefined"
                    [isAdmin]="isAdmin" [showSmartphones]="showSmartphones" [showDesktops]="showDesktops"
                    [font_color]="(selectedTemplate === 'popup' || selectedTemplate === 'carousel') ? font_color : '#000000'"
                    [height]="(selectedTemplate === 'iframe' || selectedTemplate === 'carousel' || selectedTemplate === 'stories' || selectedTemplate === 'popup' || selectedTemplate === 'inline') ? height : undefined"
                    [aspectRatio]="(selectedTemplate === 'iframe' || selectedTemplate === 'inline') ? aspectRatio : undefined"
                    [showProducts]="(selectedTemplate === 'inline' || selectedTemplate === 'stories'  || selectedTemplate === 'carousel') ? showProducts : false"
                    [showDescription]="(selectedTemplate === 'inline' || selectedTemplate === 'carousel') ? showDescription : false"
                    [selectedShape]="selectedTemplate === 'popup' ? selectedShape : undefined"
                    [bg_color]="(selectedTemplate === 'popup' || selectedTemplate === 'carousel') ? bg_color : undefined"
                    [widget_id]="widget_id" [store_id]="store_id" [template_uid]="template_uid" [widget_uid]="widget_uid"
                    (openSidebarEvent)="openSidebar()" [containerDiv]="containerDivRef" [isCol4]="isCol4"
                    [discoverDesign]="discoverDesign" [discoverIcon]="discoverIcon"
                    [discoverShowFilterBar]="discoverShowFilterBar" [discoverLayout]="discoverLayout"
                    [discoverShowPostItemBadge]="discoverShowPostItemBadge"
                    [showWidgetTitle]="nuvemshopStyledTemplates.includes(selectedTemplate) ? showWidgetTitle : false"
                    [widgetTitle]="widgetTitle" [widgetTitleTag]="widgetTitleTag"
                    [titleAlignment]="titleAlignment" [titleSpacing]="titleSpacing"
                    [paddingTop]="nuvemshopStyledTemplates.includes(selectedTemplate) ? effectivePaddingTop : 0"
                    [paddingRight]="nuvemshopStyledTemplates.includes(selectedTemplate) ? effectivePaddingRight : 0"
                    [paddingBottom]="nuvemshopStyledTemplates.includes(selectedTemplate) ? effectivePaddingBottom : 0"
                    [paddingLeft]="nuvemshopStyledTemplates.includes(selectedTemplate) ? effectivePaddingLeft : 0"
                    [paddingUnit]="paddingUnit"
                    [marginTop]="nuvemshopStyledTemplates.includes(selectedTemplate) ? effectiveMarginTop : 0"
                    [marginRight]="nuvemshopStyledTemplates.includes(selectedTemplate) ? effectiveMarginRight : 0"
                    [marginBottom]="nuvemshopStyledTemplates.includes(selectedTemplate) ? effectiveMarginBottom : 0"
                    [marginLeft]="nuvemshopStyledTemplates.includes(selectedTemplate) ? effectiveMarginLeft : 0"
                    [marginUnit]="marginUnit">
                </app-widget-template>
            </div>
        </div>
    </div>

    <!-- RIGHT: Config Panel (desktop only) -->
    <div *ngIf="!isCompactView" class="ss-l-config-panel-slot" #configPanelSlot>
        <div class="ss-l-config-panel shadow-2" [style.height.px]="layoutMaxHeightPx">
            <div class="ss-l-config-panel-header flex align-items-center justify-content-between px-3 py-3">
                <h4 class="mb-0 font-semibold text-xl">Configurações</h4>
            </div>
            <div class="ss-l-config-panel-body px-3">
                <ng-container *ngTemplateOutlet="configContent"></ng-container>
            </div>
            <div class="ss-l-config-panel-footer px-3 py-2 border-top-1 surface-border">
                <ng-container *ngTemplateOutlet="footerContent"></ng-container>
            </div>
        </div>
    </div>
</div>

<!-- Modal de Produtos -->
<p-dialog [(visible)]="displayCommandMenu" [modal]="true" [dismissableMask]="true"
    [contentStyle]="{ padding: '0', overflow: 'hidden' }"
    class="custom-command-menu ss-l-commandMenu ss-l-responsive-dialog ss-g-dialog-sized">
    <div class="search-bar">
        <div class="p-inputgroup" style="margin: 0; padding: 0;">
            <span class="p-inputgroup-addon">
                <i class="pi pi-search"></i>
            </span>
            <input type="text" pInputText [(ngModel)]="searchQuery" placeholder="Buscar produtos..."
                (input)="filterProducts()" />
        </div>
    </div>
    <div class="recent-section">
        <h4>Produtos</h4>
        <ul class="recent-list">
            <li *ngFor="let product of productsList" class="recent-item cursor-pointer"
                (click)="addProductToChips2(product)" [class.disabled]="isProductDisabled(product)">
                <div class="product-container">
                    <img [src]="product.thumbnail" alt="Product Image" class="product-thumbnail">
                    <div class="product-details">
                        <h5>{{ product.title }}</h5>
                        <p>{{ product.displayUrl || product.product_url || '' }}</p>
                    </div>
                    <a [href]="product.displayUrl || product.product_url || '#'" target="_blank" class="product-link">
                        <i class="pi pi-external-link"></i>
                    </a>
                </div>
            </li>
        </ul>
    </div>
    <ng-template pTemplate="footer">
        <div style="text-align: right;">
            <button pButton pRipple label="Fechar" (click)="closeCopyTemplate(1)" class="p-button-outlined"></button>
            <button *ngIf="createWidgetBtn" pButton pRipple label="Criar" [loading]="isLoadingSave"
                (click)="createWidget()" class="ml-2 mr-2"></button>
            <button *ngIf="!createWidgetBtn" pButton pRipple label="Salvar" [loading]="isLoadingSave"
                (click)="editWidget(1)" class="ml-2 mr-2"></button>
        </div>
    </ng-template>
</p-dialog>

<!-- Modal de Coleções -->
<p-dialog [(visible)]="displayCollectionsMenu" [modal]="true" [dismissableMask]="true"
    [contentStyle]="{ padding: '0', overflow: 'hidden' }"
    class="custom-command-menu ss-l-commandMenu ss-l-responsive-dialog ss-g-dialog-sized">
    <div class="search-bar">
        <div class="p-inputgroup" style="margin: 0; padding: 0;">
            <span class="p-inputgroup-addon">
                <i class="pi pi-search"></i>
            </span>
            <input type="text" pInputText [(ngModel)]="searchQuery" placeholder="Buscar coleções..."
                (input)="filterCollections()" />
        </div>
    </div>
    <div class="recent-section">
        <h4>Coleções</h4>
        <ul class="recent-list">
            <li *ngFor="let collection of collectionsList" class="recent-item cursor-pointer"
                (click)="addCollectionToChips(collection)" [class.disabled]="isCollectionDisabled(collection)">
                <div class="product-container">
                    <img [src]="collection.image" alt="Collection Image" class="product-thumbnail">
                    <div class="product-details">
                        <h5>{{ collection.title }}</h5>
                        <p>{{ collection.displayUrl || collection.collection_url || '' }}</p>
                    </div>
                    <a [href]="collection.displayUrl || collection.collection_url || '#'" target="_blank"
                        class="product-link">
                        <i class="pi pi-external-link"></i>
                    </a>
                </div>
            </li>
        </ul>
    </div>
    <ng-template pTemplate="footer">
        <div style="text-align: right;">
            <button pButton pRipple label="Fechar" (click)="displayCollectionsMenu = false"
                class="p-button-outlined"></button>
        </div>
    </ng-template>
</p-dialog>

<!-- Modal de Artigos -->
<p-dialog [(visible)]="displayArticlesMenu" [modal]="true" [dismissableMask]="true"
    [contentStyle]="{ padding: '0', overflow: 'hidden' }"
    class="custom-command-menu ss-l-commandMenu ss-l-responsive-dialog ss-g-dialog-sized">
    <div class="search-bar">
        <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
                <i class="pi pi-search"></i>
            </span>
            <input type="text" pInputText [(ngModel)]="searchQuery" placeholder="Buscar artigos..."
                (input)="filterArticles()" />
        </div>
    </div>
    <div class="recent-section">
        <h4>Artigos</h4>
        <ul class="recent-list">
            <li *ngFor="let article of articlesList" class="recent-item cursor-pointer"
                (click)="addArticleToChips(article)" [class.disabled]="isArticleDisabled(article)">
                <div class="product-container">
                    <img [src]="article.image" alt="Article Image" class="product-thumbnail">
                    <div class="product-details">
                        <h5>{{ article.title }}</h5>
                        <p>{{ article.displayUrl || (url_store + '/blogs/' + (article.blogTitle | slugify) + '/' +
                            article.handle) }}</p>
                    </div>
                    <a [href]="article.article_url" target="_blank" class="product-link">
                        <i class="pi pi-external-link"></i>
                    </a>
                </div>
            </li>
        </ul>
    </div>
    <ng-template pTemplate="footer">
        <div style="text-align: right;">
            <button pButton pRipple label="Fechar" (click)="displayArticlesMenu = false"
                class="p-button-outlined"></button>
        </div>
    </ng-template>
</p-dialog>

<!-- Modal de Edição existente -->
<p-dialog [(visible)]="displayEditDialog" [modal]="true" [dismissableMask]="true" [style]="{ width: '30vw' }"
    class="ss-g-dialog-sized">
    <p-header>Editar {{ selectedTemplate }}</p-header>
    <p>Você já criou um {{ selectedTemplate }} para esta página. Gostaria de editá-lo?</p>
    <ng-template pTemplate="footer">
        <button pButton label="Não" class="p-button-outlined" (click)="displayEditDialog = false"></button>
        <button pButton label="Sim" class="ml-2" (click)="redirectToEditWidget()"></button>
    </ng-template>
</p-dialog>

<app-dialog-aguarde [visible]="displayAguarde"></app-dialog-aguarde>

<p-dialog header="Header" [(visible)]="visible" position="right" [style]="{ width: '50vw' }"
    class="ss-g-dialog-sized">
    <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
        magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
        consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est
        laborum.
    </p>
</p-dialog>
